import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import clsx from "clsx"

import { languageSuffixMap } from "constant"
import { resolveStorageUrl, thousandSeparator } from "utils"
import { Card, LazyImage } from "components"
import classes from "./KflCard.module.scss"

const KflCard = (props) => {
  const {
    food,
    design
  } = props

  const history = useHistory()

  const deliveryType =
    useSelector(state => state.deliveryInfo.deliveryType)

  const [t, i18n] = useTranslation()

  const isFoodForThisDeliveryType = () => {
    if (!food.onlyThisDeliveries) return true

    if (food.onlyThisDeliveries.length === 0) return true

    return food.onlyThisDeliveries.includes(
      deliveryType
    )
  }

  const handleClick = () => {
    if (isSoldout) return

    history.push(`/kiosk-food/${food._id}`)
  }

  const option = food.options[0]

  const field =`name${languageSuffixMap[i18n.language]}`

  const foodName = food[field]

  const isSoldout =
    food.options.every(option =>
      option.outOfStock ||
      (
        option.stockManagement &&
        option.availableQuantity <= 0
      )
    )

  const percentag =
    ((option.price - option.salePrice) / option.price) * 100 | 0

  const cardDecoration =
    design.productCard.decoration || {}

  const cardDecorationImage =
    cardDecoration.enabled && cardDecoration.image
      ? resolveStorageUrl(cardDecoration.image)
      : ""

  const cardDecorationPosition =
    cardDecoration.position || {}

  if (!isFoodForThisDeliveryType()) return null

  return (
    <div className={classes["container"]}>
      <Card
        onClick={handleClick}
        data-card-variant={design.productCard.variant}
        style={{
          "--kiosk-product-card-radius": `${design.productCard.radius}px`,
          "--kiosk-product-card-image-fit": design.productCard.imageFit
        }}
        className={clsx(
          classes["card"],
          isSoldout && classes["cant-select"]
        )}
      >
        <div className={classes["image-wrapper"]}>
          {!!cardDecorationImage &&
            <img
              src={cardDecorationImage}
              alt=""
              className={classes["card-decoration"]}
              data-animation={cardDecoration.animation || "shake"}
              style={{
                "--decoration-x": `${cardDecorationPosition.x ?? 12}%`,
                "--decoration-y": `${cardDecorationPosition.y ?? 0}%`
              }}
            />
          }

          <LazyImage
            src={food.imageCover}
            imageWidth={300}
            quality={60}
            className={classes["image"]}
            alt={foodName}
          />

          {
            isSoldout &&
            <div className={classes["soldout"]}>
              {t("ناموجود")}
            </div>
          }
        </div>

        <div className={classes["details"]}>
          <div className={classes["name"]}>
            {foodName}
          </div>

          <div className={classes["footer"]}>
            {option.price > option.salePrice
              ?
              <div className={classes["row"]}>
                <div className={classes["right"]}>
                  <span className={classes["sale-price"]}>
                    {thousandSeparator(option.salePrice)}
                  </span>
                  <span className={classes["price"]}>
                    {thousandSeparator(option.price)}
                  </span>
                </div>
                <span className={classes["tag"]}>
                  {percentag}%
                </span>
              </div>
              :
              <span className={classes["sale-price"]}>
                {thousandSeparator(option.salePrice)}
              </span>
            }
          </div>
        </div>
      </Card>
    </div>
  )
}

export default React.memo(KflCard)
